// extracted by mini-css-extract-plugin
module.exports = {"report-title":"ReportTitle_report-title__IA6UK","title":"ReportTitle_title__1dXwH","sub-title":"ReportTitle_sub-title__MXnWS"};